module.exports = __webpack_public_path__ + "img/DE01674.a8770e71.png";